import { Space } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import useBreadcrumb from 'hooks/useBreadcrumb';
import { useCallbackPrompt } from 'hooks/useCallbackPrompt';
import useInvoicesConfig from 'hooks/useInvoicesConfig';
import UnsavedChangesWarningModal from 'components/new-ui/composed/modal/unsaved-changes-warning-modal/UnsavedChangesWarningModal';
import GeneralSettingsSection from '../components/general-settings-section/GeneralSettingsSection';
import InvoiceTemplateSection from '../components/invoice-template-section/InvoiceTemplateSection';
import EmailTemplateSection from '../components/email-template-section/EmailTemplateSection';
import useDirtySections from 'views/invoices/hooks/useDirtySections';
import { GeneralSettingsDirtyProvider } from './GeneralSettingsDirtyContext';

const GeneralSettings = () => {
    const { setBreadcrumbRoutes } = useBreadcrumb();
    const { config } = useInvoicesConfig();
    const { setDirty, isDirty } = useDirtySections({
        generalSettings: false,
        invoiceTemplate: true,
        emailTemplate: false,
    });

    const [isUnsavedModalOpen, setIsUnsavedModalOpen] = useState(false);

    const showUnsavedModal = useCallback(() => setIsUnsavedModalOpen(true), []);
    const { cancelNavigation, confirmNavigation } = useCallbackPrompt(isDirty, showUnsavedModal);

    const closeModal = () => {
        setIsUnsavedModalOpen(false);
    };

    const handleCancel = () => {
        cancelNavigation();
        closeModal();
    };

    const handleConfirm = () => {
        confirmNavigation();
        closeModal();
    };

    useEffect(() => {
        setBreadcrumbRoutes([
            {
                breadcrumbName: 'Home',
                path: '/home',
            },
            {
                breadcrumbName: 'Invoices',
                path: '../invoices',
            },
            {
                breadcrumbName: 'Configure Invoices',
                path: '/',
            },
        ]);
    }, [setBreadcrumbRoutes]);

    if (!config) {
        return null;
    }

    return (
        <>
            <GeneralSettingsDirtyProvider value={setDirty}>
                <Space style={{ width: '100%' }} direction="vertical" size={24}>
                    <GeneralSettingsSection />
                    <InvoiceTemplateSection />
                    <EmailTemplateSection />
                </Space>
            </GeneralSettingsDirtyProvider>

            <UnsavedChangesWarningModal open={isUnsavedModalOpen} onCancel={handleCancel} onConfirm={handleConfirm} />
        </>
    );
};

export default GeneralSettings;
